import { Button, Space, TableColumnsType, Tag } from 'antd';
import moment from 'moment';
import React from 'react';

import type { Feedback } from '@/types/database/feedback';

type FeedbackTableData = Feedback & {
  key: string;
  status: string;
};

type FeedbackAction = (feedback: Feedback) => void;

export const generateColumns = ({
  onEdit,
  onDelete,
  onReply,
  onNotify,
  order,
  orderField,
  setOrderField,
}: {
  onEdit: FeedbackAction;
  onDelete: FeedbackAction;
  onReply: FeedbackAction;
  onNotify: FeedbackAction;
  order: 'ascend' | 'descend';
  orderField: 'createdTime' | 'householdNumber' | 'type' | 'status';
  setOrderField: (
    orderField: 'createdTime' | 'householdNumber' | 'type' | 'status'
  ) => void;
}): TableColumnsType<FeedbackTableData> => {
  return [
    {
      key: 'status',
      dataIndex: 'status',
      title: '狀態',
      width: 100,
      sortOrder: orderField === 'status' ? order : undefined,
      sorter: (a, b) => a.status.localeCompare(b.status),
      onHeaderCell: () => ({
        onClick: () => setOrderField('status'),
      }),
      render: (val: string) => (
        <Tag color={val === '未回覆' ? 'red' : 'blue'}>{val}</Tag>
      ),
    },
    {
      key: 'householdNumber',
      dataIndex: 'householdNumber',
      title: '戶號',
      width: 100,
      sortOrder: orderField === 'householdNumber' ? order : undefined,
      sorter: (a, b) => a.householdNumber.localeCompare(b.householdNumber),
      onHeaderCell: () => ({
        onClick: () => setOrderField('householdNumber'),
      }),
    },
    {
      key: 'type',
      dataIndex: 'type',
      title: '類別',
      width: 100,
      sortOrder: orderField === 'type' ? order : undefined,
      sorter: (a, b) => a.type.localeCompare(b.type),
      onHeaderCell: () => ({
        onClick: () => setOrderField('type'),
      }),
    },
    {
      key: 'title',
      dataIndex: 'title',
      title: '標題',
      width: 300,
    },
    {
      key: 'createdTime',
      dataIndex: 'createdTime',
      title: '建立時間',
      width: 150,
      render: (val: string) => moment(val).format('YYYY-MM-DD HH:mm:ss'),
      sortOrder: orderField === 'createdTime' ? order : undefined,
      sorter: (a, b) => {
        return moment(a.createdTime).isBefore(moment(b.createdTime)) ? -1 : 1;
      },
      onHeaderCell: () => ({
        onClick: () => setOrderField('createdTime'),
      }),
    },
    {
      key: 'updatedTime',
      dataIndex: 'updatedTime',
      title: '更新時間',
      width: 150,
      render: (val: string) => moment(val).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      key: 'action',
      title: '操作',
      fixed: 'right',
      width: 400,
      render: (_, record) => (
        <Space direction="horizontal">
          <Button onClick={() => onReply(record)}>更多與回覆</Button>
          <Button onClick={() => onEdit(record)}>編輯</Button>
          <Button onClick={() => onNotify(record)}>通知</Button>
          <Button onClick={() => onDelete(record)} type="primary" danger>
            刪除
          </Button>
        </Space>
      ),
    },
  ];
};
